module.exports = __webpack_public_path__ + "img/TV.05b96de9.png";